<section style="background: rgb(255, 255, 255);" id="how-it-works"
    [attr.class]="isMobile ? 'section-bg-1 pt0 pb0' : 'section-bg-1'">

    <!--begin container-->
    <div class="container howItWorks">
        <!--begin row -->
        <div [attr.class]="isMobile ? 'row pd5030' : 'row pd10030'">
            <div class="col-12">
                <div class="text-center">
                    <h2 class="text-white mb-5 services">How to Send Money Overseas</h2>
                </div>
                <div class="col-12" *ngIf="country == 'hk'">
                    <p class="text-white" style="line-height: 20px; margin-left: 10%; margin-right: 10%;">We offer a
                        wide global coverage with transfers to over 180 countries worldwide. Save on every
                        transfer with the best exchange rates and low fees.
                    </p>
                </div>
            </div>
            <!--begin col-md-4 -->
            <div class="col-md-4">
                <div class="main-services hiw howWork bg-white rounded"  [attr.data-aos]="'fade-up'" data-aos-duration="1000">
                    <i class="icon-bg-2 fa-solid fa-1" id="hiw"></i>
                    <h4 class="hiwh4">Register Online</h4>
                    <p>Create your profile online <a (click)="redirectToRegistration()"><u>within 5
                                minutes</u></a> <span> or even faster with SingPass!</span>
                    </p>
                </div>
            </div>
            <!--end col-md-4 -->
            <!--begin col-md-4 -->
            <div class="col-md-4">
                <div class="main-services hiw howWork bg-white rounded" [attr.data-aos]="'fade-up'" data-aos-duration="2000">
                    <i class="icon-bg-2 fa-solid fa-2" id="hiw"></i>
                    <h4>Send the Funds</h4>
                    <p>Enter your recipient details and send money online 24/7.</p>
                </div>
            </div>
            <!--end col-md-4 -->
            <!--begin col-md-4 -->
            <div class="col-md-4">
                <div class="main-services hiw howWork bg-white rounded" [attr.data-aos]="'fade-up'" data-aos-duration="3000">
                    <i class="icon-bg-2 fa-solid fa-3" id="hiw"></i>
                    <h4>Track Your Transfers</h4>
                    <p>Track the status of your transfers anytime by logging into your account.</p>
                </div>
            </div>
            <!--end col-md-4 -->
        </div>
        <!--end row -->
        <div class="pb-5">
            <div class="col-md-12 text-center font_inter">
                <button class="btn btn-primary" style="background: #F60; border: #F60;" (click)="redirectToQuickTransfer()">Country Coverage</button>
            </div>
        </div>
    </div>
    <!--end container-->

</section>